/**
 * Anchor navigation that hands off to Lenis when smooth scrolling is active,
 * and falls back to the native behaviour otherwise.
 */
export const scrollToId = (selector) => {
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};

/** Jump to the top instantly — used when the SPA swaps pages. */
export const scrollToTop = () => {
  if (window.__lenis) {
    window.__lenis.scrollTo(0, { immediate: true });
  }
  window.scrollTo(0, 0);
};
